<template>
  <div class="pc-logo" style="height: 100vh; background: #ffffff">
    <div class="login-top">
        <span>
          <img src="../../../src/assets/l-login.png">
          <p>
            <b>欢迎登录</b>
            <b>智慧能源创新学院资源综合管理系统</b>
          </p>
        </span>
      <div class="login-name">
        <h2 class="clearfiex">用户登录</h2>
      </div>
    </div>
    <div class="reg-box">
      <div class="login-name2">
        <h2 class="clearfiex">用户登录</h2>
      </div>
      <ul>
        <li class="phone">
          <span><img src="../../../src/assets/phone2.png"></span>
          <input v-model="username" maxLength="20" name="" type="text" placeholder="请输入账号"></li>
        <li class="code">
          <span><img src="../../../src/assets/pass.png"></span>
          <input v-model="password" maxLength="20" type="password" name="" placeholder="请输入密码">
        </li>
      </ul>
      <div class="reg-but jq-but"><input @click="submit" name="" type="button" value="登录"></div>
      <div class="reg-but jq-but other-but"><input @click="$router.replace({path:'/', query: {jc: 1}})" name=""
                                                   type="button" value="使用jAccount账号登录"></div>
    </div>
  </div>
</template>


<script>
  import {browserFlag} from '@/utils/BrowserUtil'
  import Utils from '../../js/common/utils';
  import {Toast} from 'mint-ui';

  export default {
    name: "Login",
    data() {
      return {
        username: '',
        password: '',
        flag: true
      }
    },
    created() {
      if (Utils.getLocal("Authorization")) {
        this.$router.replace({name: '/'})
      }
    },
    methods: {
      submit() {
        if (!this.username) {
          Toast({message: '请输入账号', duration: 1000})
          return
        }
        if (!this.password) {
          Toast({message: '请输入密码', duration: 1000})
          return
        }
        if (this.flag) {
          this.flag = false
          R.Login.login({
            username: this.username,
            password: this.password
          }).then(res => {
            this.flag = true
            Utils.saveLocal("Authorization", res)

            if (browserFlag()) {
              this.$router.replace({path: '/'})
            } else {
              this.$router.replace({path: '/activity'})
            }
          }).catch(() => {
            this.flag = true
          })
        }
      }
    }
  }
</script>

<style scoped>
  .login-name {
    display: flex;
    border-radius: 12px 12px 0 0;
    background: #ffffff;
    width: 100%;
    height: 65px;
  }

  .login-top {
    display: flex;
    height: 50vw;
    background: url("../../../src/assets/lbg.png") center center no-repeat;
    background-size: 100%;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 15px;
  }

  .login-name h2 {
    display: flex;
    align-items: center;
    padding: 0 26px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #6988FF;
    position: relative;
  }

  .login-name h2::after {
    position: absolute;
    width: 22px;
    height: 4px;
    background: #6988FF;
    border-radius: 4px;
    bottom: 10px;
  }

  .login-top span {
    display: flex;
    height: 18vh;
    align-items: center;
  }

  .login-top span img {
    display: flex;
    width: 12vw;
    height: 12vw;
  }

  .login-top span p {
    display: flex;
    flex: 1;
    flex-direction: column;
    color: #FFFFFF;
    font-weight: bold;
    line-height: 6vw;
    padding-left: 5px;
  }

  .login-top span p b {
    font-size: 4.5vw;
  }

  .r-logo {
    display: block;
    width: 92px;
    margin: 0 auto;
    margin-top: 80px;
  }

  .r-logo img {
    width: 92px;
  }

  .reg-box {
    margin: 0 30px;
    margin-top: 50px;
  }

  .reg-box h2 {
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    padding: 38px 0;
  }

  .reg-box ul li {
    display: flex;
    align-items: center;
    height: 44px;
    background: #EDEFFC;
    margin-bottom: 20px;
    position: relative;
    border-radius: 43px;

  }

  .reg-box ul li.code {
    margin-bottom: 7vh;
  }

  .reg-box ul li input {
    float: left;
    color: #333333
  }

  .reg-box ul li span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    width: 44px;
    position: relative;
  }

  .reg-box ul li span img {
    width: 14px;
  }

  .reg-box ul li.code span img {
    position: relative;
  }

  .reg-box ul li.phone input {
    display: block;
    height: 40px;
    width: calc(100% - 44px);
    color: #7A82AE;
    font-size: 14px
  }

  .reg-box ul li.code input {
    display: block;
    height: 40px;
    width: calc(100% - 44px);
    color: #7A82AE;
    font-size: 14px
  }

  .reg-box ul li.code label {
    display: inline-block;
    width: 100px;
    height: 34px;
    border-radius: 3px;
    background: #0066cc;
    color: #FFF;
    font-size: 12px;
    text-align: center;
    line-height: 34px;
    float: right;
    position: relative;
    top: 4px;
    right: 3px;
  }

  .reg-but input {
    height: 44px;
    background: linear-gradient(-39deg, #93AAFF 0%, #6988FF 100%);
    border-radius: 45px;
    width: 100%;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .other-but input {
    display: none;
  }

  @media screen and (min-width: 1024px) {
    .login-top {
      background-size: 100% 100%;
      height: 100vw;
      position: fixed;
      width: 100%;
      top: 0;
    }

    .login-name {
      display: none;
    }

    .reg-box {
      background: #ffffff;
      position: absolute;
      padding: 10px 30px 50px 30px;
      border-radius: 24px;
      width: 500px;
    }

    .pc-logo {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .login-top span {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      /*height: 100px;*/
      padding-top: 6vh;
    }

    .login-top span img {
      width: 60px;
      height: 60px;
    }

    .login-top span p {
      display: flex;
      flex-direction: row;
      line-height: inherit;
      margin-top: 10px;
    }

    .login-top span p b {
      font-size: 24px;
    }

    .login-name2 {
      display: flex;
      border-radius: 12px 12px 0 0;
      background: #ffffff;
      width: 100%;
      height: 65px;
      margin-bottom: 10px;
    }

    .login-name2 h2 {
      display: flex;
      align-items: center;
      padding: 0 5px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #6988FF;
      position: relative;
    }

    .login-name2 h2::after {
      position: absolute;
      width: 22px;
      height: 4px;
      background: #6988FF;
      border-radius: 4px;
      bottom: 10px;
    }

    .reg-box ul li.code {
      margin-bottom: 40px;
    }

    .other-but input {
      display: block;
      margin-top: 15px;
      border: 1px solid #6988FF;
      color: #6988FF;
      background: #ffffff;
    }
  }
</style>
